import { CSSProperties, ReactNode } from "react";
import Popup from "reactjs-popup";
import { PopupPosition } from "reactjs-popup/dist/types";
import { Text } from "../Text/Text";
import styles from "./DeprecatedTooltip.module.css";

type Props = {
  trigger: JSX.Element;
  title?: string;
  contentStyle?: CSSProperties;
  direction?: PopupPosition | PopupPosition[];
  children?: ReactNode;
};

/**
 * @deprecated use Tooltip from @src/components/ui-components/Tooltip/Tooltip.tsx
 */
export const TooltipWrapper = ({ trigger, title, contentStyle, direction, children }: Props) => {
  return (
    <Popup
      trigger={<div style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>{trigger}</div>}
      on="hover"
      arrowStyle={{ color: "#f5f2f5", marginLeft: "-15px" }}
      contentStyle={contentStyle}
      position={direction ? direction : "bottom center"}
      arrow={!!title}
    >
      {(children || title) && (
        <div className={styles.popupContent}>
          {title && (
            <Text size="sm" color="secondary" fontWeight={600}>
              {title}
            </Text>
          )}

          {children}
        </div>
      )}
    </Popup>
  );
};

